import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Stat, IconType,
} from '@routific/hive';
import styled from 'styled-components';
import getHrsMinString from '../../../helpers/getHrsMinString';
import { MiniRouteContainerType } from './MiniRouteInfo';
import DarkTooltipTable from '../../shared/DarkTooltipTable';
import { WORKING_TIME_LABEL_FORMAT } from '../../../constants/routeLabels';
import TooltipBody from '../../shared/TooltipBody';

export enum GaugeSizeTypes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
interface Props {
  workingTime: number;
  duration?: number | null;
  percentWorkingTime: number;
  overtime?: boolean;
  large?: boolean;
  type?: MiniRouteContainerType;
  remainingWorkingTime?: number;
  gaugeSize?: GaugeSizeTypes;
  loading?: boolean;
  disabled?: boolean;
}

const WorkingTimeInfoItem = styled.div<{ $large?: boolean }>`
  max-width: ${({ $large }) => ($large ? '154px' : '100%')};
  display: flex;
  align-items: center;
`;

const WorkingTimeInfo: React.FC<Props> = ({
  workingTime, duration,
  percentWorkingTime, large, type,
  overtime, gaugeSize, loading = false,
  disabled,
}) => {
  const { t } = useTranslation('components');
  const totalTime = duration || workingTime;

  const getWorkingTimeString = () => (loading ? '--' : t('constraintUtilization.workingTime.label.consumption.text', { hours: getHrsMinString(workingTime) }));
  const getDurationString = () => (loading ? '--' : t('sidebar.hrs', { hours: getHrsMinString(duration || 0) }));

  const getTooltipContent = () => (
    <>
      <TooltipBody text={t('constraintUtilization.workingTime.title')} />
      <DarkTooltipTable
        data-cy="working-time-info-tooltip"
        used={t(WORKING_TIME_LABEL_FORMAT, { hours: getHrsMinString(workingTime) || 0 })}
        total={t(WORKING_TIME_LABEL_FORMAT, { hours: getHrsMinString(totalTime) })}
        overCap={overtime}
      />
    </>
  );

  return (
    <WorkingTimeInfoItem
      data-cy={type && `${type}-route-utilization-working-time`}
      data-testid={type && `${type}-route-utilization-working-time`}
      className="item"
      $large={large}
    >
      <Stat
        percent={percentWorkingTime}
        constraintViolated={overtime}
        icon={IconType.Time}
        size={gaugeSize}
        label={{
          value: getWorkingTimeString(), capacity: duration ? `/ ${getDurationString()}` : undefined,
        }}
        tooltipContent={getTooltipContent()}
        disabled={disabled}
      />
    </WorkingTimeInfoItem>
  );
};

export default WorkingTimeInfo;
